import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "app",
  class: "flex flex-col min-h-screen"
}
const _hoisted_2 = { class: "bg-surface-0 shadow-md py-2 px-4" }
const _hoisted_3 = { class: "container mx-auto flex justify-between items-center" }
const _hoisted_4 = { class: "flex-grow" }

import UserMenu from "@/components/UserMenu.vue";
import "./assets/global.css";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "text-xl font-bold text-primary-800 hover:text-primary-600 transition-colors"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Post.ly ")
          ]),
          _: 1
        }),
        _createVNode(UserMenu)
      ])
    ]),
    _createElementVNode("main", _hoisted_4, [
      _createVNode(_component_router_view)
    ])
  ]))
}
}

})